import { Commit } from "vuex";
import { http } from "../../plugins/axios";

export interface SicknessExtState {}

const state = (): SicknessExtState => ({});

const mutations = {};

const getters = {};

const actions = {
  async createSicknessExtApplication(
    { commit }: { commit: Commit },
    data: any
  ) {
    const endpoint = "/application/sickness";

    const res = await http.post(endpoint, data);

    return res.data;
  },
  async getSicknessExtTypes() {
    const endpoint = "/application/Sickness_Extension/types";

    const res = await http.get(endpoint);

    return res.data;
  },
  async getEligibleBenefits() {
    const endpoint = "/application/sickness";

    const res = await http.get(endpoint);

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
